import TextIconGroup from './TextIconGroup';
import { TextIconGroupProps, TextIconGroupValueProps } from './types';

export type { TextIconGroupProps, TextIconGroupValueProps };
export default TextIconGroup;
